// ヘッダーの高さを考慮したスクロール先アンカー対象
import styled from "styled-components";

const AnchorTarget = styled.a`
  position: relative;
  visibility: hidden;
  display: block;
  @media screen and (max-width: 960px) {
    top: -70px;
  }
  @media screen and (min-width: 961px) {
    top: -116px;
  }
`;
export default AnchorTarget;
